(function () {
    'use strict';

    var serviceId = 'commonAttach';
    angular.module('app').factory(serviceId, ['$rootScope', 'common', 'datacontext', 'bootstrap.dialog', '_', '$window', fn_commonAttach]);

    function fn_commonAttach($rootScope, common, datacontext, bDialog, _, window) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(serviceId);
        var logError = getLogFn(serviceId, 'logError');
        var logSuccess = getLogFn(serviceId, 'logSuccess');

        var service = {
            // generic
            changeStateAttach: changeStateAttach
            , extractCADESFile: extractCADESFile
            , extractVerifySignInfo: extractVerifySignInfo
            , safeDownload: safeDownload
            , getBySource: getBySource
            , getTSource: getTSource
            , getTAttach: getTAttach
            , setfAttach: setfAttach
            , getListAttach: getListAttach
            , deleteAttach: deleteAttach

        };
        return service;

        // ******************************
        //  Funzioni Generiche

        function changeStateAttach(item, code) {
            var msg = '';
            switch (code) {
                case 'completed':
                    msg = 'Stai impostando l\'allegato ' + item.Name + ' nello stato "BLOCCATO". Procedere? ';
                    break;
                case 'not-completed':
                    msg = 'Stai rimuovendo per l\'allegato ' + item.Name + ' lo stato "BLOCCATO". Procedere? ';
                    break;
                case 'sent':
                    msg = 'Stai impostando l\'allegato ' + item.Name + ' nello stato "VERIFICATO". Procedere? ';
                    break;
                case 'not-sent':
                    msg = 'Stai rimuovendo per l\'allegato ' + item.Name + ' lo stato "VERIFICATO". Procedere? ';
                    break;
            }

            bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
                function () { //YES
                    return datacontext.attach_changeState(item.Id, code).then(function (data) {
                        if (data != "204") {
                            switch (code) {
                                case 'completed':
                                    item.Completed = false;
                                    break;
                                case 'not-completed':
                                    item.Completed = true;
                                    break;
                                case 'sent':
                                    item.Sent = false;
                                    break;
                                case 'not-sent':
                                    item.Sent = true;
                                    break;
                            }

                            return logError('Attenzione si \xE8 verifcato un errore.');
                        }

                        switch (code) {
                            case 'completed':
                                item.Completed = true;
                                break;
                            case 'not-completed':
                                item.Completed = false;
                                break;
                            case 'sent':
                                item.Sent = true;
                                break;
                            case 'not-sent':
                                item.Sent = false;
                                break;
                        }

                        return logSuccess('Record aggiornato');
                    });
                },
                function () { //NO
                    log('exit');
                }
            );
        }


        function extractCADESFile(id) {
            return datacontext.attach_extract(id).then(function (data) {
                if (data == "ERR01") return logError("Errore: il documento non \xE8 un documento 'P7M-CADES' valido. ");
                if (data == "ERR02") return logError("Errore: documento non trovato. ");
                if (data == "ERR03") return logError("Errore: il documento non ha firma digitale. ");

                var url = data;
                window.open(url, 'Download');
            });
        }

        function extractVerifySignInfo(id) {
            var fileName = "";
            return datacontext.attach_extractDigitalSignInfo(id).then(function (data) {
                fileName = data;

                if (data) {
                    common.$http.get('/api/pdf/GetVerifySign?id=' + id, { responseType: 'arraybuffer' })
                        .then(function (response) {
                            if (response.status == 204) {

                                logError('Il documento non ha Firma Digitale');
                                return;
                            }

                            var file = new Blob([response.data], { type: 'application/pdf' });
                            var fileURL = URL.createObjectURL(file);
                            fileName = fileName.substring(0, fileName.indexOf('.'));

                            window.open(fileURL, fileName);

                            //var a = document.createElement("a");
                            //a.href = fileURL;
                            //a.setAttribute('style', 'display:none');
                            //a.setAttribute('target', '_blank');
                            //document.body.appendChild(a);

                            //if ($rootScope.detectIE())
                            //    window.navigator.msSaveBlob(file, 'VerificaFirma_' + fileName + '.pdf');
                            //else
                            //    a.download = 'VerificaFirma_' + fileName + '.pdf';

                            //a.click();
                            //document.body.removeChild(a);
                        })
                        .catch(function (message) {
                            logError('Impossibile scaricare il file');
                        });
                }

            });

        }

        function safeDownload(id) {
            return datacontext.attach_safeDownload(id).then(function (data) {
                if (data.startsWith("ERR02")) return logError("Errore: documento non trovato. [" + data + ']');

                var url = data;
                var name = data.substr(data.lastIndexOf('/') + 1);

                window.open(url, name);

                //var a = document.createElement('A');
                //a.href = data;
                //a.setAttribute('target', '_blank');
                //a.download = data.substr(data.lastIndexOf('/') + 1);
                //document.body.appendChild(a);
                //a.click();
                //document.body.removeChild(a);

                return true;

            });
        }

        function getBySource(tSourceCode, sourceId) {
            if (!sourceId) return;
            console.info('getBySource', tSourceCode, sourceId);
            return datacontext.attach_getBySource(tSourceCode, sourceId).then(function (data) {
                console.info('attachBySource', data);
                return data;
            });
        }

        function getTSource(code, vm) {
            if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
            });
        }
        function getTAttach(code, vm) {
            if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
            });
        }


        function setfAttach(vm) {
            if (vm.checkfAttach == false) {
                vm.fAttach.TAttachId = '';
            }
        }

        function getListAttach(id, vm, tSourceCode_def) {
            if (!id) return;

            if (vm.fAttach.TAttachId == '' || vm.fAttach.TAttachId == null || typeof vm.fAttach.TAttachId == 'undefined') {
                vm.fAttach.TAttachId = 0;
            }

            return datacontext.attach_getAll(0, 0, id, 0, tSourceCode_def, 0, 0, '', vm.fAttach.TAttachId, 0, '').then(function (data) {
                vm.list.b_attach = true;
                if (!$.isNumeric(data)) vm.list.attach = data;

                return datacontext.tAttachVisibility_getAuth(tSourceCode_def).then(function (data_TAV) {
                    var tAttVis = data_TAV;

                    vm.list.attach.forEach(function (item_A) {
                        var myTAV = _.find(tAttVis, { 'TAttachId': item_A.TAttachId });

                        if (typeof myTAV == 'undefined') {
                            myTAV = {};
                            myTAV.bRead = true;
                            myTAV.bInsert = true;
                            myTAV.bUpdate = true;
                            myTAV.bDelete = true;
                            myTAV.iTags = 0;
                        }

                        item_A.bRead = myTAV.bRead;
                        item_A.bInsert = myTAV.bInsert;
                        item_A.bUpdate = myTAV.bUpdate;
                        item_A.bDelete = myTAV.bDelete;
                        item_A.iTags = myTAV.iTags;
                        item_A.AbleEdit = ((myTAV.iTags & 16384) == 16384);
                        item_A.AbleDelete = ((myTAV.iTags & 32768) == 32768);

                        if (!item_A.bRead) {
                            var index = vm.list.attach.indexOf(item_A);
                            vm.list.attach.splice(index, 1);
                        }

                    });

                    if (!Array.isArray(data)) {
                        data = [];
                    }
                    console.info('list.attach', data);
                    return vm.list.attach = data;
                });
            });
        }

        function deleteAttach(item, vm) {
            var msg = ' Allegato ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError('Attenzione: entit\xE0 bloccata. ');
                    if (data == "401") return logError('Attenzione: azione non autorizzata. ');
                    if (data == "404") return logError('Attenzione: entit\xE0 inesistente. ');
                    if (data == "417") return bDialog.errorDialog('Attenzione: azione non permessa, perch\xE8 entit\xE0 bloccata in cascata da altri elementi. ');

                    var index = vm.list.attach.indexOf(item);
                    vm.list.attach.splice(index, 1);
                });
            });
        }

    }
})();